<div fxLayout="row" fxLayoutAlign="space-between">
  <h2 mat-dialog-title>{{ title | startCase }}</h2>
  <button mat-icon-button [matDialogClose]="">
    <mat-icon>close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  @if (images.length === 1) {
    <div>
      <img class="image" src="{{images[0].url}}" alt="image"/>
    </div>
  } @else {
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" [selectedIndex]="selectedImageIndex">
      @for (image of images; track image; let i = $index) {
        <mat-tab label="{{image.filename?.substring(0, image.filename.indexOf('.')) || ('image ' + (i + 1)) | startCase}}">
          <img class="image" src="{{image.url}}" alt=""/>
        </mat-tab>
      }
    </mat-tab-group>
  }
</mat-dialog-content>
